/* eslint-disable react/jsx-props-no-spreading */
import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'

/**
 * Delivery-date screen. **A stub — COM-948 fills it in.**
 *
 * COM-947 registers the container type and this template together, because
 * `BaseContainer`'s `assertEveryContainerTypeHandled` fails the build when a
 * union member has no `case`. Registering both now is what lets COM-948,
 * COM-949 and COM-950 branch in parallel.
 *
 * **It fetches nothing on purpose, and that is the one thing to change.**
 * COM-948 calls `useLazyGetCheckoutRule` with
 * `CheckoutRules.DELIVERY_DATES` on mount, writes the result through
 * `checkoutSlice.setAvailable`, and writes the shopper's pick through
 * `setCheckoutRuleSession` before navigating back to the cart. Until then this
 * renders whatever the config authored and no calendar.
 *
 * ⚠️ **Expect at most one date, and plan for none.** `getCheckoutRule` passes
 * no `requestData`, so the resolver's external-API branch is unreachable and
 * every answer comes from `resolveDefaultDates` — a single computed day —
 * filtered by `validateDates` to strictly after today. A calendar is the right
 * control for what this rule *can* offer, not for what the pilot returns
 * today. Verify against a live response before building for a range.
 *
 * **No route exists in code.** Cinnamon builds its routes from the SCS
 * config's own `routes` array, and `defaultConfig` ships none for this. The
 * screen is unreachable until a storefront authors the route, the container
 * and a `pushView` onto it — COM-951 does that for the pilot.
 */
const DeliveryDatePicker: FC<ITemplate> = ({ ...props }) => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])

  return <Default {...props} />
}

export default DeliveryDatePicker
